module.exports = __webpack_public_path__ + "img/footer-1-6.9b95d9cf.png";